package one.healthium.ui.compose.theme.styles

import androidx.compose.material3.ButtonColors
import androidx.compose.runtime.Composable
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.Shape
import one.healthium.ui.compose.components.AppButtonDefaults
import one.healthium.ui.compose.components.resolve
import one.healthium.ui.compose.theme.AppTheme
import one.healthium.ui.compose.theme.black75
import one.healthium.ui.compose.theme.white

data class HealthKitBannerStyle(
    private val containerColor: Color? = null,
    private val contentColor: Color? = null,
    private val shape: Shape? = null,
    private val actionButtonStyleRef: AppButtonStyleRef? = null,
) {
    val containerColorOrDefault: Color
        @Composable get() = containerColor ?: AppTheme.colors.secondary

    val contentColorOrDefault: Color
        @Composable get() = contentColor ?: AppTheme.colors.onSecondary

    val shapeOrDefault: Shape
        @Composable get() = shape ?: AppTheme.shapes.large

    val actionButtonStyle: ButtonColors
        @Composable get() = actionButtonStyleRef?.resolve() ?: AppButtonDefaults.appButtonColors(
            containerColor = black75,
            contentColor = white,
        )
}